// extracted by mini-css-extract-plugin
module.exports = {"container":"Images_container__pDOUn","figure":"Images_figure__G2A4q"};